export default __webpack_public_path__ + "static/media/clipboard-outline.ae2db6c2.svg";